<div class="person-in-marina-panel">
  <p-fieldset class="full-panel">
    <p-header class="article-title">
      <span class="article-title">{{ "PESSOAS-NA-MARINA.TITLE" | translate }}</span>
      <button
        class="fab-button primary"
        (click)="load()"
        pTooltip="Atualizar"
        tooltipPosition="bottom"
      >
        <i class="pi pi-refresh" [ngClass]="{ 'pi-spin': loading }"></i>
      </button>
    </p-header>

    <!-- Filtros -->
    <div class="filter-bar">
      <div class="filter-group">
        <label>{{ "PESSOAS-NA-MARINA.FILTER-TYPE" | translate }}</label>
        <p-dropdown
          [options]="typeOptions"
          [(ngModel)]="filter.type"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="{{ 'PESSOAS-NA-MARINA.ALL-TYPES' | translate }}"
          (onChange)="onFilterChange()"
          appendTo="body"
        >
          <ng-template let-selectedItem pTemplate="selectedItem">
            {{ selectedItem ? (selectedItem.label | translate) : '' }}
          </ng-template>
          <ng-template let-item pTemplate="item">
            {{ item.label | translate }}
          </ng-template>
        </p-dropdown>
      </div>
      <div class="filter-group" *ngIf="showResponsibleFilter()">
        <label>{{ "PESSOAS-NA-MARINA.FILTER-RESPONSIBLE" | translate }}</label>
        <p-dropdown
          [options]="responsiblePresentOptions"
          [(ngModel)]="filter.isResponsiblePresent"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="{{ 'PESSOAS-NA-MARINA.ALL' | translate }}"
          (onChange)="onFilterChange()"
          appendTo="body"
        >
          <ng-template let-selectedItem pTemplate="selectedItem">
            {{ selectedItem ? (selectedItem.label | translate) : '' }}
          </ng-template>
          <ng-template let-item pTemplate="item">
            {{ item.label | translate }}
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <!-- Conteúdo -->
    <div class="panel-content">
      <div class="loading-overlay" *ngIf="loading">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>

      <div class="table-wrapper" *ngIf="!loading && list.length > 0">
        <p-table
          #tt
          [value]="list"
          [paginator]="true"
          [rows]="50"
          [rowsPerPageOptions]="[50, 10, 20, 30]"
          [resizableColumns]="true"
          [autoLayout]="true"
          [globalFilterFields]="['name', 'type', 'codRegistration', 'lastAccessPointName']"
          styleClass="easy-table"
        >
          <ng-template pTemplate="caption">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                size="40"
                [placeholder]="'GENERAL-SEARCH-PAGINATED' | translate"
                (input)="tt.filterGlobal($event.target.value, 'contains')"
                style="width: auto"
              />
            </span>
            <span class="table-total">
              {{ "TOTAL-REGISTERS" | translate }}: {{ list.length }}
            </span>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 2.5rem"></th>
              <th style="width: 3rem">{{ "PHOTO" | translate }}</th>
              <th [pSortableColumn]="'name'">
                {{ "NAME" | translate }}
                <p-sortIcon [field]="'name'"></p-sortIcon>
              </th>
              <th *ngIf="showCodRegistrationColumn()" [pSortableColumn]="'codRegistration'">
                {{ "PESSOAS-NA-MARINA.COD-REGISTRATION" | translate }}
                <p-sortIcon [field]="'codRegistration'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'colectId'">
                {{ "PESSOAS-NA-MARINA.COLLECT-ID" | translate }}
                <p-sortIcon [field]="'colectId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'lastAccessPointName'">
                {{ "PESSOAS-NA-MARINA.LAST-ACCESS-POINT" | translate }}
                <p-sortIcon [field]="'lastAccessPointName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'lastAccessPointUseDate'">
                {{ "PESSOAS-NA-MARINA.LAST-ACCESS-TIME" | translate }}
                <p-sortIcon [field]="'lastAccessPointUseDate'"></p-sortIcon>
              </th>
              <th *ngIf="showResponsibleColumn()">
                {{ "PESSOAS-NA-MARINA.FILTER-RESPONSIBLE" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-person>
            <tr>
              <td>
                <span
                  class="type-icon"
                  [ngClass]="getTypeCssClass(person.type)"
                  [pTooltip]="getTypeLabel(person.type) | translate"
                  tooltipPosition="top"
                >
                  <i class="pi" [ngClass]="getTypeIcon(person.type)"></i>
                </span>
              </td>
              <td>
                <img
                  *ngIf="person.photoUrl"
                  [src]="person.photoUrl"
                  alt=""
                  class="person-photo"
                />
                <span *ngIf="!person.photoUrl" class="person-photo-placeholder">
                  <i class="pi pi-user"></i>
                </span>
              </td>
              <td>{{ person.name }}</td>
              <td *ngIf="showCodRegistrationColumn()">{{ person.type === 'CUSTOMER' ? (person.codRegistration || '-') : '-' }}</td>
              <td>{{ person.colectId ? '#' + person.colectId : '-' }}</td>
              <td>{{ person.lastAccessPointName || '-' }}</td>
              <td>{{ person.lastAccessPointUseDate ? (person.lastAccessPointUseDate | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
              <td *ngIf="showResponsibleColumn()">
                <span
                  *ngIf="person.type === 'VISITOR' && person.isResponsiblePresent !== undefined"
                  class="badge badge-pill"
                  [ngClass]="person.isResponsiblePresent ? 'success' : 'danger'"
                >
                  <i class="pi" [ngClass]="person.isResponsiblePresent ? 'pi-check-circle' : 'pi-times-circle'"></i>
                  {{ (person.isResponsiblePresent ? 'PESSOAS-NA-MARINA.RESPONSIBLE-PRESENT' : 'PESSOAS-NA-MARINA.RESPONSIBLE-ABSENT') | translate }}
                </span>
                <span *ngIf="person.type !== 'VISITOR'">-</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="getEmptyColspan()" class="empty-row">
                {{ "PESSOAS-NA-MARINA.EMPTY" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="empty-state" *ngIf="!loading && list.length === 0">
        <i class="pi pi-inbox empty-icon"></i>
        <p>{{ "PESSOAS-NA-MARINA.EMPTY" | translate }}</p>
      </div>
    </div>
  </p-fieldset>
</div>
